import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/readme': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528.3 46.5c26.4 0.2 47.7 21.7 47.7 48.1v245.7c0 26.5-21.5 48-48 48h-89.7c-102.1 0-132.6 24.4-147.3 75-0.8 2.8-5.3 2.8-6 0-14.6-50.6-45.1-75-147.3-75h-89.7c-26.5 0-48-21.5-48-48v-245.8c0-26.5 21.5-48 48-48h139.7c48.1 0 89.8 33.3 100.4 80.3 10.5-47 52.3-80.3 100.4-80.3h139.8zM242 311.9h0.1v-22.9c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.9c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5zM242 251h0.1v-22.9c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.9c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5zM242 190.1h0.1v-22.9c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.9c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5zM501.3 311.8h0.1v-22.9c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.9c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5zM501.3 250.9h0.1v-22.9c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.9c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5zM501.3 190h0.1v-22.8c0-2-1.6-3.5-3.5-3.5h-160.4c-2 0-3.5 1.6-3.5 3.5v22.8c0 2 1.6 3.5 3.5 3.5h160.3c2 0 3.5-1.6 3.5-3.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/readme.js
// module id = 985
// module chunks = 0